import { useEffect } from "react";
import { useQueryClient, useQuery } from "react-query";
import { getSiteConfig } from "../api";

function usePrefetchConfig() {
  const queryClient = useQueryClient();

  useEffect(() => {
    async function prefetchConfig() {
      await queryClient.prefetchQuery("config", getSiteConfig);
    }

    prefetchConfig();
  }, [queryClient]);
}

function useConfig() {
  const configInfo = useQuery("config", getSiteConfig);

  return configInfo.data?.data;
}

function useConfigFeature(name) {
  const config = useConfig();

  // This is useful to secretly test toggled off features in production.
  if (typeof window !== "undefined") {
    if (window.localStorage.getItem(`__testing__${name}`) === "true") {
      return true;
    }
  }

  return config?.features?.[name] === true;
}

function useConfigConstant(name) {
  const config = useConfig();

  return config?.constants?.[name];
}

export { usePrefetchConfig, useConfig, useConfigFeature, useConfigConstant };
